import React, { useState } from 'react';
import { AlertTriangle, CheckCircle2, Circle, CloudOff, FlaskConical, Loader2 } from 'lucide-react';
import { OwnerButton, OwnerShell } from '../OwnerShell';
import { FlowSteps } from '../FlowSteps';
import { ownerProfile } from '../../../data/ownerProfile';
import type { BrtaOutcome, OwnerNav } from '../../../types/owner';
type Phase = 'idle' | 'loading' | 'done';
const outcomes: {
  key: BrtaOutcome;
  label: string;
}[] = [{
  key: 'matched',
  label: 'তথ্য মিলেছে'
}, {
  key: 'mismatch',
  label: 'অমিল রয়েছে'
}, {
  key: 'unavailable',
  label: 'BRTA অনুপলব্ধ'
}];
export function OwnerBrtaCheck({
  nav
}: {
  nav: OwnerNav;
}) {
  const [phase, setPhase] = useState<Phase>('idle');
  const d = nav.draft;
  const o = nav.brtaOutcome;
  const rows: {
    label: string;
    mine: string;
    brta: string;
    mismatch?: boolean;
  }[] = [{
    label: 'রেজিস্ট্রেশন নম্বর',
    mine: d.reg,
    brta: d.reg
  }, {
    label: 'মালিকের নাম',
    mine: ownerProfile.name,
    brta: ownerProfile.name
  }, {
    label: 'চেসিস নম্বর',
    mine: d.chassis,
    brta: d.chassis
  }, {
    label: 'ইঞ্জিন নম্বর',
    mine: d.engine,
    brta: o === 'mismatch' ? d.engine.slice(0, -1) + '0' : d.engine,
    mismatch: o === 'mismatch'
  }, {
    label: 'নিবন্ধনের তারিখ',
    mine: d.regDate,
    brta: d.regDate
  }, {
    label: 'ফিটনেসের মেয়াদ',
    mine: '৩০/০৬/২০২৭',
    brta: '৩০/০৬/২০২৭'
  }, {
    label: 'ট্যাক্স টোকেনের মেয়াদ',
    mine: '৩০/০৯/২০২৭',
    brta: o === 'mismatch' ? '৩১/১২/২০২৫' : '৩০/০৯/২০২৭',
    mismatch: o === 'mismatch'
  }];
  const run = () => {
    setPhase('loading');
    window.setTimeout(() => setPhase('done'), 1300);
  };
  const banner = phase !== 'done' ? null : o === 'matched' ? <div className="flex items-start gap-2.5 rounded-xl border border-emerald-200 bg-emerald-50 p-3 text-emerald-800" data-id="element-1380" data-mp="35on920gp895a">
        <CheckCircle2 className="h-6 w-6 shrink-0" data-id="element-1381" data-mp="kwbprwoeinyl" />
        <div data-id="element-1382" data-mp="kvieciehzaa4"><p className="font-semibold" data-id="element-1383" data-mp="kvs4q73gfjgc">✓ তথ্য মিলেছে</p><p className="text-[11.5px]" data-id="element-1384" data-mp="pvelurmeljuf">আপনার দেওয়া সকল তথ্য BRTA রেকর্ডের সাথে মিলেছে।</p></div>
      </div> : o === 'mismatch' ? <div className="flex items-start gap-2.5 rounded-xl border border-amber-200 bg-amber-50 p-3 text-amber-800" data-id="element-1385" data-mp="2lxhypstagvhz">
        <AlertTriangle className="h-6 w-6 shrink-0" data-id="element-1386" data-mp="2hwei343f2vfp" />
        <div data-id="element-1387" data-mp="2vwgvad0s50om"><p className="font-semibold" data-id="element-1388" data-mp="2vx8sfsa0z6h0">! তথ্যের অমিল রয়েছে</p><p className="text-[11.5px]" data-id="element-1389" data-mp="2vvxnvq8r9uou">২টি তথ্য BRTA রেকর্ডের সাথে মেলেনি। সংশোধন করুন অথবা ব্যাখ্যাসহ জমা দিন — ডিএমপি কর্মকর্তা যাচাই করবেন।</p></div>
      </div> : <div className="flex items-start gap-2.5 rounded-xl border border-slate-200 bg-slate-100 p-3 text-slate-700" data-id="element-1390" data-mp="23936j278jbfl">
        <CloudOff className="h-6 w-6 shrink-0" data-id="element-1391" data-mp="1yajld40gu3oa" />
        <div data-id="element-1392" data-mp="2cxl47ak7x2f0"><p className="font-semibold" data-id="element-1393" data-mp="2cxl65g3s3chn">BRTA তথ্য সাময়িকভাবে পাওয়া যাচ্ছে না</p><p className="text-[11.5px]" data-id="element-1394" data-mp="2czo2sizfs3vc">আপনি আবেদন জমা দিতে পারবেন; ডিএমপি কর্মকর্তা পরে ম্যানুয়ালি যাচাই করবেন।</p></div>
      </div>;
  return <OwnerShell nav={nav} title="BRTA তথ্য মিলিয়ে দেখুন" subtitle={d.reg} bodyClassName="p-0" footer={phase !== 'done' ? <OwnerButton onClick={run} disabled={phase === 'loading'} data-id="element-1396" data-mp="3r5ss29299h5y">
            {phase === 'loading' ? <><Loader2 className="h-4 w-4 animate-spin" data-id="element-1397" data-mp="3vwj1bxdsy45x" />যাচাই হচ্ছে…</> : 'তথ্য যাচাই করুন'}
          </OwnerButton> : o === 'mismatch' ? <div className="grid grid-cols-2 gap-2" data-id="element-1398" data-mp="3i6filge4ssl8">
            <OwnerButton variant="outline" onClick={() => {
      nav.back();
      nav.back();
    }} data-id="element-1399" data-mp="3m6pqwzpebv39">তথ্য সংশোধন করুন</OwnerButton>
            <OwnerButton onClick={() => nav.go('selfVerify')} data-id="element-1400" data-mp="dqeghuvvkhhg">অমিলসহ এগিয়ে যান</OwnerButton>
          </div> : <OwnerButton onClick={() => nav.go('selfVerify')} data-id="element-1401" data-mp="ioy2twedrvac">পরবর্তী — স্ব-যাচাই</OwnerButton>} data-id="element-1395" data-mp="1kgsc7wqnclt3">
      <FlowSteps current={3} data-id="element-1402" data-mp="4pq0iumx871x" />
      <div className="space-y-3 px-4 py-4" data-id="element-1403" data-mp="4skjehqadjt8">
        <div className="rounded-xl border border-dashed border-amber-300 bg-amber-50/70 p-3" data-id="element-1404" data-mp="9ojcgimk7pzz">
          <p className="flex items-center gap-1.5 text-[11.5px] font-semibold text-amber-800" data-id="element-1405" data-mp="2pg78mbtr1ehq"><FlaskConical className="h-3.5 w-3.5" data-id="element-1406" data-mp="2ufa1yz0d9w9v" />সিমুলেটেড BRTA যাচাই — লাইভ API সংযোগ নেই</p>
          <div className="mt-2 grid grid-cols-3 gap-1 rounded-lg bg-white p-1" role="radiogroup" aria-label="সিমুলেশন ফলাফল" data-id="element-1407" data-mp="39ox2wz1cb327">
            {outcomes.map(x => <button key={x.key} role="radio" aria-checked={o === x.key} onClick={() => {
            nav.setBrtaOutcome(x.key);
            setPhase('idle');
          }} className={`rounded-md py-1.5 text-[11px] font-semibold ${o === x.key ? 'bg-navy-800 text-white' : 'text-slate-600'}`} data-id="element-1408" data-mp="34wdnrxn07zva">
                {x.label}
              </button>)}
          </div>
        </div>

        {banner}

        <div className="overflow-hidden rounded-xl border border-border bg-white shadow-sm" data-id="element-1409" data-mp="3nq9hb60uqwlz">
          <div className="grid grid-cols-[1fr_1fr_28px] gap-2 bg-slate-50 px-3 py-2 text-[11px] font-semibold text-slate-500" data-id="element-1410" data-mp="3jmbikwffvntg">
            <span data-id="element-1411" data-mp="3eo094mt23fbr">আপনার দেওয়া তথ্য</span>
            <span data-id="element-1412" data-mp="287y0673gg0kt">BRTA রেকর্ড</span>
            <span data-id="element-1413" data-mp="288z7q1l9i4xs" />
          </div>
          {rows.map(r => {
          const pending = phase !== 'done' || o === 'unavailable';
          return <div key={r.label} className={`border-t border-slate-100 px-3 py-2.5 ${!pending && r.mismatch ? 'bg-amber-50/70' : ''}`} data-id="element-1414" data-mp="irc41uwdbjwo">
                <p className="mb-1 text-[11px] text-slate-500" data-id="element-1415" data-mp="nqyiu8ruh87l">{r.label}</p>
                <div className="grid grid-cols-[1fr_1fr_28px] items-center gap-2 text-[12.5px]" data-id="element-1416" data-mp="rr8qdpvac6ok">
                  <span className="break-all font-medium text-navy-900" data-id="element-1417" data-mp="wj0i43q6giga">{r.mine}</span>
                  <span className={`break-all font-medium ${pending ? 'text-slate-300' : r.mismatch ? 'text-amber-700' : 'text-navy-900'}`} data-id="element-1418" data-mp="11htt9phzrxda">
                    {phase === 'loading' ? <span className="block h-3 w-16 animate-pulse rounded bg-slate-200" data-id="element-1419" data-mp="16irbg2304res" /> : pending ? '—' : r.brta}
                  </span>
                  <span aria-label={pending ? 'যাচাই অপেক্ষমাণ' : r.mismatch ? 'অমিল' : 'মিলেছে'} data-id="element-1420" data-mp="1fhuwhblqbgvx">
                    {pending ? <Circle className="h-5 w-5 text-slate-300" data-id="element-1421" data-mp="3d7w7hixsihdz" /> : r.mismatch ? <AlertTriangle className="h-5 w-5 text-amber-600" data-id="element-1422" data-mp="3d9h218k3u0bu" /> : <CheckCircle2 className="h-5 w-5 text-emerald-600" data-id="element-1423" data-mp="3h9he4mjqdzfq" />}
                  </span>
                </div>
              </div>;
        })}
        </div>
        <div className="flex flex-wrap gap-3 text-[11px] text-slate-500" data-id="element-1424" data-mp="jfo1wzwgcfgz">
          <span className="flex items-center gap-1" data-id="element-1425" data-mp="xexiw1shfdm0"><CheckCircle2 className="h-3.5 w-3.5 text-emerald-600" data-id="element-1426" data-mp="xfyty69i003q" />তথ্য মিলেছে</span>
          <span className="flex items-center gap-1" data-id="element-1427" data-mp="td2jx3y0xcbe"><AlertTriangle className="h-3.5 w-3.5 text-amber-600" data-id="element-1428" data-mp="tc0utvk6apao" />তথ্যের অমিল রয়েছে</span>
          <span className="flex items-center gap-1" data-id="element-1429" data-mp="17bir0vzst4u2"><Circle className="h-3.5 w-3.5 text-slate-300" data-id="element-1430" data-mp="12e0dster03g9" />যাচাই অপেক্ষমাণ</span>
        </div>
      </div>
    </OwnerShell>;
}